import { render, staticRenderFns } from "./TeamAllMembers.vue?vue&type=template&id=13a0b27d&scoped=true&lang=pug&"
import script from "./TeamAllMembers.vue?vue&type=script&lang=js&"
export * from "./TeamAllMembers.vue?vue&type=script&lang=js&"
import style0 from "./TeamAllMembers.vue?vue&type=style&index=0&id=13a0b27d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0b27d",
  null
  
)

export default component.exports